(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("sharedReports", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/reports/sharedReportsView.html",
            controller: ["$localStorage", "$state", SharedReportsCtrl],
            controllerAs: "vm"
        };
        function SharedReportsCtrl($localStorage, $state) {
            var vm = this;
            if (!$localStorage.sharedReports) {
                $localStorage.sharedReports = [
                    {
                        name: "Learning Paths Expired",
                        report: "Learning Path Completion",
                        state: "main.reporting.learningPathCompletion",
                        filters: '{ "name":{ "enabled":false, "value":"" },"organization":{ "enabled":false, "value":"" },"groups":{ "enabled":false, "value":{ } },"pathName":{ "enabled":false, "value":"" },"assignedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"activatedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"completedDate":{ "enabled":false, "fromValue":"", "toValue":"" },"expiresDate":{ "enabled":false, "fromValue":"", "toValue":"" },"status":{ "enabled":true, "value":[4] } }'
                    }
                ];
            }
            vm.reports = $localStorage.sharedReports;
            angular.forEach(vm.reports, function (report) {
                report.params = JSON.parse(report.filters);
            });
            vm.viewReport = function (report) {
                $state.go(report.state, { filter: report.params });
            };
            vm.scheduleReport = function (report) {
                $state.go("main.reporting.scheduledReports", { report: report });
            };
        }
    });
}());
